module.exports = __webpack_public_path__ + "img/twitter.a8ac2bdf.svg";